<div class="mb-3 icon-picker-container">
  <button *ngFor="let icon of filteredIcons| slice:0:30" type="button"
    class="btn btn-outline px-3 mb-2 ml-0 mr-2" [title]="icon.name" [innerHtml]="icon.svgTagString | safeHtml" (click)="selectedIcon(icon)"></button>
  <div class="py-4 text-center" *ngIf="!filteredIcons.length">No results found.</div>
</div>